import { takeEvery } from 'redux-saga/effects';

import * as signUpActions from 'store/modules/auth/signUp';
import { signUp } from './utils';

export default function* listenSignUp() {
  yield takeEvery(signUpActions.signUp.toString(), signUp);
}
